<template>
<div id="chart">
  <apexchart type="donut" :options="chartOptions" :series="series"></apexchart>
</div>
</template>

<script>
export default {
  data: () => ({
    dataSets: [{"count":72,"method":"GET"},{"count":48,"method":"POST"},{"count":4,"method":"DELETE"}],
  }),

  computed: {
    series() {
      return this.dataSets.map(data => data.count)
    },
    chartOptions() {
      return {
      chart: {
        type: 'donut',
      },
      labels: this.dataSets.map(data => data.method),
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 200
          },
          legend: {
            position: 'bottom'
          }
        }
      }]
    }
    }
  }
}
</script>
